import { name as packageName, version as packageVersion, } from '../version.json';
export default {
    packageName: packageName,
    packageVersion: packageVersion,
};
//# sourceMappingURL=package-context.js.map